import React from 'react';

import { MainLayout } from '@confluence/main-layout';
import { Screen } from '@confluence/screen';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import {
	LazySpaceReportsSiteSettings,
	ADMIN_SPACE_REPORT_SCREEN,
} from '@confluence/site-settings/entry-points/spaceReports';

export const AdminSpaceReportsRoute = () => (
	<Screen
		screenEvent={{
			name: ADMIN_SPACE_REPORT_SCREEN,
		}}
	>
		<MainLayout navView={ADMIN_HOME_ID}>
			<LazySpaceReportsSiteSettings />
		</MainLayout>
	</Screen>
);
